export class ResponseTable{
    title!:string;
    headers!: any[];
    items!:any[];
}